// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N-5O","col":"styles_col__lmVSC"};